import React from 'react';
import Container from 'react-bootstrap/esm/Container';
import { contx } from '../../../App';
import logo from './tmtm-logo.png';

const Privacy = () => {
    const { lang } = React.useContext(contx);
    const isEn = lang === 'en';
    const align = isEn ? 'left' : 'right';

    return (
        <div style={{ width: '100%', backgroundColor: '#F3F4F6' }} dir={isEn ? 'ltr' : 'rtl'}>
            <Container className='py-5'>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1.5rem' }}>
                    <img
                        src={logo}
                        alt="TMTM logo"
                        style={{
                            width: '90px',
                            height: '90px',
                            borderRadius: '20px',
                            border: '2px solid #005247',
                            padding: '8px',
                            backgroundColor: '#ffffff'
                        }}
                    />
                </div>
                <h1 style={{ color: '#005247', marginBottom: '0.5rem', textAlign: align }}>
                    {isEn ? 'Privacy Policy' : 'سياسة الخصوصية'}
                </h1>
                <p style={{ color: '#555', marginBottom: '2rem', textAlign: align }}>
                    {isEn ? 'Last Updated: 12 July 2025' : 'آخر تحديث: 12 يوليو 2025'}
                </p>

                {/* 1. Introduction */}
                <section style={{ marginBottom: '2rem', textAlign: align }}>
                    <p style={{ fontSize: '16px', lineHeight: 1.7 }}>
                        {isEn
                            ? 'Tatweer Al Afkar Company (TMTM App) (“we,” “us,” or “our”) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application and website (collectively, the “Service”), in accordance with applicable privacy laws and the data-protection requirements of the app platforms on which our Service is available, including but not limited to the Apple App Store and Google Play.'
                            : 'تلتزم شركة تطوير الأفكار (تطبيق TMTM) (“نحن” أو “لنا”) بحماية خصوصيتك. توضح سياسة الخصوصية هذه كيفية جمع واستخدام والكشف عن وحماية معلوماتك عند استخدام تطبيقنا على الهاتف المحمول وموقعنا الإلكتروني (ويُشار إليهما معًا بـ “الخدمة”)، وذلك وفقًا لقوانين الخصوصية المعمول بها ومتطلبات حماية البيانات الخاصة بمنصات التطبيقات التي تتوفر عليها خدمتنا، بما في ذلك على سبيل المثال لا الحصر متجر Apple App Store و Google Play.'}
                    </p>
                    <p style={{ fontSize: '16px', lineHeight: 1.7, marginTop: '1rem' }}>
                        {isEn
                            ? 'Please read this policy carefully. By using our Services, you agree to the collection and use of information in accordance with this policy. If you do not agree with the terms, please do not use the application or website.'
                            : 'يرجى قراءة هذه السياسة بعناية. باستخدامك لخدماتنا، فإنك توافق على جمع واستخدام المعلومات وفقًا لهذه السياسة. إذا لم توافق على الشروط، يرجى عدم استخدام التطبيق أو الموقع الإلكتروني.'}
                    </p>
                </section>

                {/* 2. Information We Collect */}
                <section style={{ marginBottom: '2rem', textAlign: align }}>
                    <h3 style={{ color: '#005247', marginBottom: '1rem' }}>
                        {isEn ? '1. Information We Collect' : '1- المعلومات التي نجمعها'}
                    </h3>

                    <h4 style={{ fontSize: '18px', marginBottom: '0.5rem' }}>
                        {isEn ? 'A. Personal Information You Provide' : 'أ. المعلومات الشخصية التي تقدمها'}
                    </h4>
                    <p style={{ fontSize: '16px', lineHeight: 1.7 }}>
                        {isEn
                            ? 'When you register on the app or website, make purchases, or contact us, we may collect information such as:'
                            : 'عند التسجيل في التطبيق أو الموقع، أو إجراء عمليات شراء، أو التواصل معنا، قد نجمع معلومات مثل:'}
                    </p>
                    <ul style={{ fontSize: '16px', lineHeight: 1.7, paddingInlineStart: isEn ? '1.5rem' : '1.5rem' }}>
                        <li>{isEn ? 'Full name' : 'الاسم الكامل'}</li>
                        <li>{isEn ? 'National ID number' : 'رقم الهوية الوطنية'}</li>
                        <li>{isEn ? 'Email address' : 'البريد الإلكتروني'}</li>
                        <li>{isEn ? 'Phone number' : 'رقم الهاتف'}</li>
                        <li>
                            {isEn
                                ? 'Payment details (processed securely through third-party payment providers)'
                                : 'تفاصيل الدفع (تُعالج بشكل آمن عبر مزودي خدمات دفع من جهات خارجية)'}
                        </li>
                    </ul>

                    <h4 style={{ fontSize: '18px', marginTop: '1rem', marginBottom: '0.5rem' }}>
                        {isEn ? 'B. Information Collected Automatically' : 'ب. المعلومات التي يتم جمعها تلقائيًا'}
                    </h4>
                    <p style={{ fontSize: '16px', lineHeight: 1.7 }}>
                        {isEn
                            ? 'When you use the Service, we may automatically collect:'
                            : 'عند استخدامك للخدمة، نقوم تلقائيًا بجمع:'}
                    </p>
                    <ul style={{ fontSize: '16px', lineHeight: 1.7, paddingInlineStart: isEn ? '1.5rem' : '1.5rem' }}>
                        <li>{isEn ? 'National ID information' : 'معلومات الهوية الوطنية'}</li>
                        <li>{isEn ? 'Passport information' : 'معلومات جواز السفر'}</li>
                    </ul>
                    <p style={{ fontSize: '16px', lineHeight: 1.7 }}>
                        {isEn
                            ? 'This data is used for analytics, fraud prevention, and improving user experience.'
                            : 'تُستخدم هذه البيانات لأغراض التحليل، ومنع الاحتيال، وتحسين تجربة المستخدم.'}
                    </p>
                </section>

                {/* 3. How We Use Your Information */}
                <section style={{ marginBottom: '2rem', textAlign: align }}>
                    <h3 style={{ color: '#005247', marginBottom: '1rem' }}>
                        {isEn ? '2. How We Use Your Information' : '2- استخدام معلوماتك'}
                    </h3>
                    <p style={{ fontSize: '16px', lineHeight: 1.7 }}>
                        {isEn ? 'We use your data to:' : 'نستخدم بياناتك من أجل:'}
                    </p>
                    <ul style={{ fontSize: '16px', lineHeight: 1.7, paddingInlineStart: isEn ? '1.5rem' : '1.5rem' }}>
                        <li>
                            {isEn
                                ? 'Provide and improve the Service'
                                : 'تقديم الخدمة وتحسينها'}
                        </li>
                        <li>
                            {isEn
                                ? 'Process orders and transactions'
                                : 'معالجة الطلبات والمعاملات'}
                        </li>
                        <li>
                            {isEn
                                ? 'Send updates and order confirmations'
                                : 'إرسال التحديثات وتأكيدات الطلبات'}
                        </li>
                        <li>
                            {isEn
                                ? 'Detect and prevent fraud or security threats'
                                : 'اكتشاف ومنع الاحتيال أو التهديدات الأمنية'}
                        </li>
                        <li>
                            {isEn
                                ? 'Comply with legal obligations'
                                : 'الامتثال للالتزامات القانونية'}
                        </li>
                    </ul>
                </section>

                {/* 4. Sharing of Information */}
                <section style={{ marginBottom: '2rem', textAlign: align }}>
                    <h3 style={{ color: '#005247', marginBottom: '1rem' }}>
                        {isEn ? '3. Sharing of Information' : '3- مشاركة المعلومات'}
                    </h3>
                    <p style={{ fontSize: '16px', lineHeight: 1.7 }}>
                        {isEn
                            ? 'We do not sell your personal data. We may share your information with:'
                            : 'نحن لا نبيع بياناتك الشخصية. قد نشارك معلوماتك مع:'}
                    </p>
                    <ul style={{ fontSize: '16px', lineHeight: 1.7, paddingInlineStart: isEn ? '1.5rem' : '1.5rem' }}>
                        <li>
                            {isEn
                                ? 'Service providers such as payment gateways and analytics providers'
                                : 'مزودي الخدمات: مثل بوابات الدفع ومزودي خدمات التحليلات'}
                        </li>
                        <li>
                            {isEn
                                ? 'Affiliates under common control for business operations'
                                : 'الشركات التابعة الخاضعة لسيطرة مشتركة لأغراض تشغيل الأعمال'}
                        </li>
                        <li>
                            {isEn
                                ? 'Government authorities when legally required or to protect legal rights'
                                : 'الجهات الحكومية عند طلبها قانونيًا أو لحماية الحقوق القانونية'}
                        </li>
                    </ul>
                </section>

                {/* 5. Data Storage and Security */}
                <section style={{ marginBottom: '2rem', textAlign: align }}>
                    <h3 style={{ color: '#005247', marginBottom: '1rem' }}>
                        {isEn ? '4. Data Storage and Security' : '4- تخزين البيانات وأمنها'}
                    </h3>
                    <p style={{ fontSize: '16px', lineHeight: 1.7 }}>
                        {isEn
                            ? 'We implement appropriate security measures to protect your data; however, no system is completely secure. You are responsible for maintaining the confidentiality of your login credentials.'
                            : 'نطبق إجراءات أمنية مناسبة لحماية بياناتك، ومع ذلك لا يوجد نظام آمن بشكل كامل. أنت مسؤول عن الحفاظ على سرية بيانات تسجيل الدخول الخاصة بك.'}
                    </p>
                    <p style={{ fontSize: '16px', lineHeight: 1.7, marginTop: '1rem' }}>
                        {isEn
                            ? 'Data is stored in secure databases hosted on compliant cloud services and may be processed or stored outside Iraq.'
                            : 'يتم تخزين البيانات في قواعد بيانات آمنة مستضافة على خدمات سحابية متوافقة، وقد تُعالج أو تُخزن خارج العراق.'}
                    </p>
                </section>

                {/* 6. Children’s Privacy */}
                <section style={{ marginBottom: '2rem', textAlign: align }}>
                    <h3 style={{ color: '#005247', marginBottom: '1rem' }}>
                        {isEn ? '5. Children’s Privacy' : '5- خصوصية الأطفال'}
                    </h3>
                    <p style={{ fontSize: '16px', lineHeight: 1.7 }}>
                        {isEn
                            ? 'Our Services are not directed to children under 13 years of age, and we do not knowingly collect their personal data. If we discover that such data has been collected, we will delete it promptly.'
                            : 'خدماتنا غير موجهة للأطفال دون سن 13 عامًا، ولا نقوم بجمع بيانات شخصية منهم عن علم. إذا اكتشفنا جمع مثل هذه البيانات، فسنقوم بحذفها فورًا.'}
                    </p>
                </section>

                {/* 7. Your Rights */}
                <section style={{ marginBottom: '2rem', textAlign: align }}>
                    <h3 style={{ color: '#005247', marginBottom: '1rem' }}>
                        {isEn ? '6. Your Rights' : '6- حقوقك'}
                    </h3>
                    <p style={{ fontSize: '16px', lineHeight: 1.7 }}>
                        {isEn ? 'You may:' : 'يمكنك:'}
                    </p>
                    <ul style={{ fontSize: '16px', lineHeight: 1.7, paddingInlineStart: isEn ? '1.5rem' : '1.5rem' }}>
                        <li>
                            {isEn
                                ? 'Request access to your personal data'
                                : 'طلب الوصول إلى بياناتك الشخصية'}
                        </li>
                        <li>
                            {isEn
                                ? 'Update or correct your information'
                                : 'تحديث أو تصحيح معلوماتك'}
                        </li>
                        <li>
                            {isEn
                                ? 'Delete your account and data'
                                : 'حذف حسابك وبياناتك'}
                        </li>
                    </ul>
                    <p style={{ fontSize: '16px', lineHeight: 1.7 }}>
                        {isEn
                            ? 'To do so, please contact us using the details below.'
                            : 'للقيام بذلك، تواصل معنا عبر معلومات الاتصال أدناه.'}
                    </p>
                </section>

                {/* 8. Changes to This Privacy Policy */}
                <section style={{ marginBottom: '2rem', textAlign: align }}>
                    <h3 style={{ color: '#005247', marginBottom: '1rem' }}>
                        {isEn ? '7. Changes to This Privacy Policy' : '7- التغييرات على سياسة الخصوصية'}
                    </h3>
                    <p style={{ fontSize: '16px', lineHeight: 1.7 }}>
                        {isEn
                            ? 'We may update this policy from time to time. Updates will be posted on this page, and significant changes will be communicated via the app or email. Continued use of the Service constitutes acceptance of the changes.'
                            : 'قد نقوم بتحديث هذه السياسة من وقت لآخر. سيتم نشر التحديثات على هذه الصفحة، وسيتم إبلاغك بالتغييرات المهمة عبر التطبيق أو البريد الإلكتروني. استمرارك في استخدام الخدمة يعني موافقتك على التعديلات.'}
                    </p>
                </section>

                {/* 9. Governing Law */}
                <section style={{ marginBottom: '2rem', textAlign: align }}>
                    <h3 style={{ color: '#005247', marginBottom: '1rem' }}>
                        {isEn ? '8. Governing Law' : '8- القانون الحاكم'}
                    </h3>
                    <p style={{ fontSize: '16px', lineHeight: 1.7 }}>
                        {isEn
                            ? 'This Privacy Policy is governed by the laws of the Republic of Iraq. Any disputes shall be resolved before the courts of Baghdad, Iraq.'
                            : 'تخضع سياسة الخصوصية هذه لقوانين جمهورية العراق، وأي نزاعات تُحل أمام محاكم بغداد، العراق.'}
                    </p>
                </section>

                {/* 10. Intellectual Property */}
                <section style={{ marginBottom: '2rem', textAlign: align }}>
                    <h3 style={{ color: '#005247', marginBottom: '1rem' }}>
                        {isEn ? '9. Intellectual Property' : '9- الملكية الفكرية'}
                    </h3>
                    <p style={{ fontSize: '16px', lineHeight: 1.7 }}>
                        {isEn
                            ? 'All intellectual property rights related to Tatweer Al Afkar Company, particularly concerning the TMTM application—including but not limited to trademarks, logos, trade names, designs, texts, images, software, databases, and content published on the website or app—are the exclusive property of the company or legally licensed to it.'
                            : 'جميع حقوق الملكية الفكرية المتعلقة بشركة تطوير الأفكار، وخصوصًا بما يخص تطبيق TMTM، بما في ذلك على سبيل المثال لا الحصر: العلامات التجارية، الشعارات، الأسماء التجارية، التصاميم، النصوص، الصور، البرمجيات، قواعد البيانات، والمحتوى المنشور على الموقع أو التطبيق، هي ملك حصري للشركة أو مرخصة لها بشكل قانوني.'}
                    </p>
                    <p style={{ fontSize: '16px', lineHeight: 1.7, marginTop: '1rem' }}>
                        {isEn
                            ? 'Copying, reproducing, distributing, modifying, or using any part of these materials without prior written consent from the company is prohibited. Any unauthorized use may result in legal liability under applicable intellectual property laws.'
                            : 'يُمنع نسخ أو إعادة إنتاج أو توزيع أو تعديل أو استخدام أي جزء من هذه المواد دون الحصول على موافقة خطية مسبقة من الشركة. أي استخدام غير مصرح به قد يعرّض صاحبه للمساءلة القانونية وفقًا لقوانين الملكية الفكرية المعمول بها.'}
                    </p>
                </section>

                {/* 11. Contact Us */}
                <section style={{ marginBottom: '1rem', textAlign: align }}>
                    <h3 style={{ color: '#005247', marginBottom: '1rem' }}>
                        {isEn ? '10. Contact Us' : '10- اتصل بنا'}
                    </h3>
                    <p style={{ fontSize: '16px', lineHeight: 1.7 }}>
                        {isEn
                            ? 'If you have any questions or concerns about this Privacy Policy or your personal data, you can contact us at:'
                            : 'إذا كانت لديك أسئلة أو مخاوف حول سياسة الخصوصية أو بياناتك الشخصية، يمكنك التواصل معنا عبر:'}
                    </p>
                    <ul style={{ fontSize: '16px', lineHeight: 1.7, paddingInlineStart: isEn ? '1.5rem' : '1.5rem' }}>
                        <li>
                            {isEn ? 'Email: info@tatweer-iq.net' : 'البريد الإلكتروني: info@tatweer-iq.net'}
                        </li>
                        <li>
                            {isEn ? 'Website: www.tatweer-iq.net' : 'الموقع الإلكتروني: www.tatweer-iq.net'}
                        </li>
                        <li>
                            {isEn
                                ? 'Address: Karrada, Baghdad, Iraq, near Al-Masbah intersection'
                                : 'العنوان: كرادة، بغداد، العراق، قرب تقاطع المسبح'}
                        </li>
                    </ul>
                </section>
            </Container>
        </div>
    );
};

export default Privacy;

